import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken, refreshToken } from '@app/helpers/auth/oidc';
import navigationService from '@app/services/navigationService';

const handleAuthFailure = () => {
  // Use navigation service to avoid circular dependency
  navigationService.triggerAuthFailure();
};

export const createBaseQueryWithReAuth = () => {
  const baseQuery = fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: headers => {
      const accessToken = getAccessToken();

      headers.set('Authorization', `Bearer ${accessToken}`);
      headers.set('content-type', 'application/json');

      return headers;
    },
  });

  const baseQueryWithReAuth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error?.status === 403) {
      handleAuthFailure();
      return result;
    }

    if (result.error?.status === 401) {
      try {
        await refreshToken();
        result = await baseQuery(args, api, extraOptions);

        // If we still get 401 after refresh, authentication has failed
        if (result.error?.status === 401) {
          // eslint-disable-next-line no-console
          console.error(
            'Authentication failed after token refresh, redirecting to logout',
          );
          handleAuthFailure();
          return result;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to refresh token, redirecting to logout:', error);
        handleAuthFailure();
        return result;
      }
    }

    return result;
  };

  return baseQueryWithReAuth;
};
